import { SynchTripResultImportDTO } from 'business/models/Models';
import React from 'react';

interface ImportSynchTripResult {
  fileContent;
  setFileContent;
  setNextButtonDisallowed;
  synchTripResultImportDTOList: SynchTripResultImportDTO[];
  setSynchTripResultImportDTOList;
}

const ImportSynchTripResultContext = React.createContext<ImportSynchTripResult>({
  fileContent: null,
  setFileContent: (val) => {},
  setNextButtonDisallowed: (val) => {},
  synchTripResultImportDTOList: null,
  setSynchTripResultImportDTOList: (val) => {},
});

export default ImportSynchTripResultContext;
